import createScriptTag from '../../helpers/DOM/createScriptTag'
import insertScript from '../../helpers/DOM/insertScript'
import WebModel from '../../models/WebModel'
const espScript = 'https://oa.openxcdn.net/esp.js'

export class OpenX {
  static insertESPscript(model: WebModel) {
    if (!model.openx) {
      return
    }
    const script = createScriptTag(espScript)
    insertScript(script)
  }
}
